import { CALL_API } from "../../../middlewares/api";

export const DEPOT_FETCH_REQUEST = "DEPOT_FETCH_REQUEST";
export const DEPOT_FETCH_SUCCESS = "DEPOT_FETCH_SUCCESS";
export const DEPOT_FETCH_ERROR = "DEPOT_FETCH_ERROR";

export function fetch_depot(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/depotsummary/byaccountid?accountId=" + accountId,
      authenticatedRequest: true,
      method: "GET",
      additionalData: accountId,
      types: [DEPOT_FETCH_REQUEST, DEPOT_FETCH_SUCCESS, DEPOT_FETCH_ERROR],
    },
  };
}

export function fetch_borrower_depot(accountId, depotId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/depotsummary/borrowerdepot?depotId=" + depotId,
      authenticatedRequest: true,
      method: "GET",
      additionalData: accountId,
      types: [DEPOT_FETCH_REQUEST, DEPOT_FETCH_SUCCESS, DEPOT_FETCH_ERROR],
    },
  };
}

export const TRANSFER_TO_SAVELEND_ACCOUNT_REQUEST =
  "TRANSFER_TO_SAVELEND_ACCOUNT_REQUEST";
export const TRANSFER_TO_SAVELEND_ACCOUNT_SUCCESS =
  "TRANSFER_TO_SAVELEND_ACCOUNT_SUCCESS";
export const TRANSFER_TO_SAVELEND_ACCOUNT_ERROR =
  "TRANSFER_TO_SAVELEND_ACCOUNT_ERROR";

export function transfer_money_to_savelend_depot(identity, amount) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/transfer-excess",
      authenticatedRequest: true,
      method: "POST",
      data: { Identity: identity, Amount: amount },
      types: [
        TRANSFER_TO_SAVELEND_ACCOUNT_REQUEST,
        TRANSFER_TO_SAVELEND_ACCOUNT_SUCCESS,
        TRANSFER_TO_SAVELEND_ACCOUNT_ERROR,
      ],
    },
  };
}

export const GET_HOLDINGS_FOR_DERPOD_REQUEST =
  "GET_HOLDINGS_FOR_DERPOD_REQUEST";
export const GET_HOLDINGS_FOR_DERPOD_SUCCESS =
  "GET_HOLDINGS_FOR_DERPOD_SUCCESS";
export const GET_HOLDINGS_FOR_DERPOD_ERROR = "GET_HOLDINGS_FOR_DERPOD_ERROR";

export function get_holdings_for_depot(depotid) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/holdings/byportfolio?PortfolioId=" + depotid,
      authenticatedRequest: true,
      method: "GET",
      additionalData: depotid,
      types: [
        GET_HOLDINGS_FOR_DERPOD_REQUEST,
        GET_HOLDINGS_FOR_DERPOD_SUCCESS,
        GET_HOLDINGS_FOR_DERPOD_ERROR,
      ],
    },
  };
}

export const ADD_DEPOT_REQUEST = "ADD_DEPOT_REQUEST";
export const ADD_DEPOT_SUCCESS = "ADD_DEPOT_SUCCESS";
export const ADD_DEPOT_ERROR = "ADD_DEPOT_ERROR";

export function add_depot(accountId, depotName, currency) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/investors/add-depot",
      authenticatedRequest: true,
      method: "POST",
      data: { InvestorId: accountId, Label: depotName, Currency: currency },
      additionalData: accountId,
      types: [
        ADD_DEPOT_REQUEST,
        { method: successOnAddedDepot.bind(this, accountId) },
        ADD_DEPOT_ERROR,
      ],
    },
  };
}

function successOnAddedDepot(accountId, response) {
  return (dispatch) => {
    dispatch({
      type: ADD_DEPOT_SUCCESS,
      response,
    });

    dispatch(fetch_depot(accountId));
  };
}
